<template>
    <v-row justify="center" class="ma-n1">
        <v-col cols="auto" class="pa-1">
            <v-btn :outlined="form.isSuccess !== true" width="150" :color="form.isSuccess === true ? 'primary' : 'grey-d'" class="d-flex justify-space-between" @click.capture="emit(true)">
                <span :class="{ 'grey--text': form.isSuccess != true }"> 채용 </span>
                <v-simple-checkbox :value="form.isSuccess === true" @click.prevent />
            </v-btn>
        </v-col>
        <v-col cols="auto" class="pa-1">
            <v-btn :outlined="form.isSuccess !== false" width="150" :color="form.isSuccess === false ? 'primary' : 'grey-d'" class="d-flex justify-space-between" @click.capture="emit(false)">
                <span :class="{ 'grey--text': form.isSuccess == true }"> 미채용 </span>
                <v-simple-checkbox :value="form.isSuccess === false" @click.prevent />
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { initExpoMatching } from "@/assets/variables/inits";

export default {
    props: {
        value: { type: Object, default: initExpoMatching }, // form
    },
    data: () => ({
        form: initExpoMatching(),
    }),
    methods: {
        sync() {
            this.form = initExpoMatching(this.value);
        },
        emit(isSuccess) {
            this.form.isSuccess = isSuccess;
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>
